module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_01_1280_1280_ko-9d30c16684f726abcd91669392a43a4f.jpg";